import React from 'react'
import PropTypes from 'prop-types'
import './FirstStep.sass'

const FirstStep = ({
 color,
 procedure,
 selectedOption,
 handleOptionChange
}) => (
  <ul className={`firstStep ${color}`}>
    <li className="firstStep__caption"><span />
      {procedure && procedure.length === 1 ? 'Тип получения услуги' : 'Выберите тип получения услуги'}
    </li>
    {procedure && Object.keys(procedure).map(procedureName=>(
      <li key={procedureName} className="firstStep__radio-wrapper field-radio-group">
        <div className="option-wrapper">
          <input
            className="firstStep__radio"
            type="radio"
            id={`service-quest__${procedureName}`}
            value={procedureName}
            checked={selectedOption === procedureName}
            onChange={handleOptionChange}
          />
          {/* eslint-disable */}
          <label className="firstStep__label" htmlFor={`service-quest__${procedureName}`}>
            {Object.values(procedure[procedureName].name).map(name=>name)}
          </label>
          {/* eslint-disable */}
        </div>
      </li>
    ))}
  </ul>
)

FirstStep.propTypes = {
  color: PropTypes.string,
  selectedOption: PropTypes.string.isRequired,
  procedure: PropTypes.object.isRequired,
  handleOptionChange: PropTypes.func.isRequired
}

FirstStep.defaultProps = {
  color: 'primary'
}

export default FirstStep



// WEBPACK FOOTER //
// ./components/Service_FirstStep/index.jsx